import { useMemo } from "react";

import { useTranslation } from "react-i18next";

import { useGetClinicPartnersMembers } from "api/services/clinic_partner/hooks";

export const ALL_MEMBERS = "all";

export type MemberValue = number | typeof ALL_MEMBERS;

export const useFilterOptions = () => {
  const { t } = useTranslation();

  const { data: clinicPartnersMembersData } = useGetClinicPartnersMembers();
  const clinicPartnersMembers = clinicPartnersMembersData?.items || [];

  const clinicPartnersMembersOptions = useMemo(
    () => [
      { label: t("clinic_partner.all_clinic_partners_members"), value: ALL_MEMBERS },
      ...(clinicPartnersMembers || []).map(clinicPartnersMember => ({
        label: clinicPartnersMember.name,
        value: clinicPartnersMember.id,
      })),
    ],
    [clinicPartnersMembers, t]
  );

  return { clinicPartnersMembersOptions };
};
